export const EVENT_DETAILS_READ_MODE_FULL = "full"
export const EVENT_DETAILS_READ_MODE_SHELL = "shell"
export const EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS = "announcements"
export const EVENT_DETAILS_READ_MODE_COMPETITION = "competition"

const shellBackedTabs = new Set(["details", "competitions", "logistics"])
const announcementsBackedTabs = new Set(["announcements"])
const selectedCompetitionBackedTabs = new Set([
  "details",
  "entries",
  "phases",
  "draw",
  "penalties",
  "matches",
  "points",
])

export const getEventDetailsReadModeForTab = tab =>
  shellBackedTabs.has(tab)
    ? EVENT_DETAILS_READ_MODE_SHELL
    : announcementsBackedTabs.has(tab)
    ? EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS
    : EVENT_DETAILS_READ_MODE_FULL

export const getCompetitionDetailsReadModeForTab = tab =>
  tab === "details" ? EVENT_DETAILS_READ_MODE_SHELL : selectedCompetitionBackedTabs.has(tab)
    ? EVENT_DETAILS_READ_MODE_COMPETITION
    : EVENT_DETAILS_READ_MODE_FULL
